/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import MaximizableView from '../../MaximizableView';

export default function ChartView(props) {
  const { global30 } = props;
  const lineOptions = {
    legend: {
      labels: {
        fontColor: '#3388ff',
      },
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: false,
          drawBorder: true,
        },
        ticks: {
          fontColor: '#3388ff',
        },
      }],
      yAxes: [{
        gridLines: {
          display: false,
          drawBorder: true,
        },
        ticks: {
          fontColor: '#3388ff',
          userCallback(value) {
            value = value.toString().split(/(?=(?:...)*$)/).join(' ');
            return value;
          },
        },
      }],
      tooltips: {
        backgroundColor: '#000f1a',
        fontColor: '#3388ff',
      },
    },
  };

  return (
    <MaximizableView>
      <Line
        data={global30}
        options={lineOptions}
      />
    </MaximizableView>
  );
}

ChartView.propTypes = {
  global30: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      timeSeries: PropTypes.arrayOf(PropTypes.string),
      fill: PropTypes.bool,
      borderColor: PropTypes.string,
    })),
  }).isRequired,
};
